import { useTranslation } from "react-i18next";
import { supportedLanguages, type SupportedLanguage } from "@/i18n";

const LABELS: Record<SupportedLanguage, string> = {
  en: "EN",
  zh: "中文",
};

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { t, i18n } = useTranslation("app");

  const resolvedLanguage = i18n.resolvedLanguage ?? i18n.language;
  const currentLang =
    supportedLanguages.find((lang) => resolvedLanguage.startsWith(lang)) ??
    "en";

  return (
    <fieldset
      aria-label={t("language.label")}
      className={`inline-flex items-center rounded-full border border-divider p-0.5 text-[11px] font-semibold ${className}`}
    >
      {supportedLanguages.map((lang) => (
        <button
          key={lang}
          type="button"
          aria-current={lang === currentLang ? "true" : undefined}
          onClick={() => void i18n.changeLanguage(lang)}
          className={`rounded-full px-2.5 py-1 transition-colors ${
            lang === currentLang
              ? "bg-primary text-primary-foreground"
              : "text-default-500 hover:text-foreground"
          }`}
        >
          {LABELS[lang] ?? lang.toUpperCase()}
        </button>
      ))}
    </fieldset>
  );
}
